import { render, staticRenderFns } from "./WhatsappOrder.vue?vue&type=template&id=911c810e&"
import script from "./WhatsappOrder.vue?vue&type=script&lang=js&"
export * from "./WhatsappOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports